// 阿里矢量图标库配置
let iconfontVersion = ['567566_pwc3oottzol'];
let iconfontUrl = `//at.alicdn.com/t/font_$key.css`;
let baseUrl = '';
let codeUrl = `${baseUrl}/code`
const env = process.env;
let picUrl = '' //da
    // http://zhhb.azureflying.com:8201 //正式环境
    // `http://192.168.199.165`;        // bin
    // `http://116.62.114.125:8201/`     //测试环境
    // `http://wxb.vaiwan.com`;         // 标`
    // `http://web.azureflying.com `; 
if (env.NODE_ENV === 'development') {
    baseUrl = `http://www.azureflying.com:8201 `; // 零时地址
    picUrl = ''; //平时为空
} else if (env.NODE_ENV === 'production') {
    baseUrl = `http://www.azureflying.com:8201 `;
    picUrl = ''; //生产环境的加上
} else if (env.NODE_ENV === 'test') {
    baseUrl = `http://www.azureflying.com:8201 `;
}

export {
    baseUrl,
    picUrl,
    iconfontUrl,
    iconfontVersion,
    codeUrl,
    env,
}